//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { prevent_cat_add, prevent_cate_list, prevent_cate_del } from '@/api/pests';
import addAppCustom from './components/addCustom';
import noData from '@/view/components/noData/noData';
export default {
  data: function data() {
    return {
      list: [],
      spinShow: false
    };
  },
  components: {
    noData: noData
  },
  methods: {
    clickList: function clickList(item) {
      for (var i = 0; i < this.list.length; i++) {
        if (item.id === this.list[i].id) {
          this.$set(this.list[i], 'check', true);
        } else {
          this.$set(this.list[i], 'check', false);
        }
      }

      this.$emit('checkList', item);
    },
    init: function init() {
      var _this2 = this;

      this.spinShow = true;
      prevent_cate_list().then(function (res) {
        _this2.spinShow = false;

        if (res.result === 0) {
          _this2.list = res.body.list || [];

          if (_this2.list.length > 0) {
            _this2.clickList(_this2.list[0]);
          }
        }
      });
    },
    add: function add() {
      var vm = this;
      var config = {
        loading: true,
        width: 400,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '新增防制分类'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addAppCustom, {
            ref: 'addAppCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              prevent_cat_add(formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del: function del(row) {
      var vm = this;
      var config = {
        loading: true,
        title: this.$t('删除'),
        content: this.$t('您确定要删除') + row.cate_name + '?',
        onOk: function onOk() {
          var _this = this;

          prevent_cate_del({
            id: row.id
          }).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function mounted() {
    this.init();
  }
};